export type TagResource = {
  tag?: Tag;
  isError: boolean;
};

export type Tag = {
  id: number;
  value: string;
  url: string;
  image: string;
};

export enum TagSize {
  Small = "tag-size-small",
  Big = "tag-size-big",
}
